import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import GeoView from 'views/customers/geo'; // Importing GeoView component
import MoneyView from 'views/customers/money'; // Importing MoneyView component
import AgeView from 'views/customers/age'; // Importing AgeView component
import TagsView from 'views/customers/tags'; // Importing TagsView component
import PositionsView from 'views/customers/positions'; // Importing PositionsView component
import JugadoresActivosView from 'views/dashboard/jugadoresActivos'; // Importing JugadoresActivosView component
import JugadoresNuevosView from 'views/dashboard/jugadoresNuevos'; // Importing JugadoresNuevosView component
import DataView from 'views/dashboard/dataview'; // Importing DataView component
import { devConfig, profile, walletcode } from '../config/config'; // Importing configuration settings

/**
 * BettingView class extends JetView to create a betting interface.
 */
export default class BettingView extends JetView {
    /**
     * Configures the UI components for the BettingView.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var toDateLocal; // Variable for local 'to' date
        var fromDateLocal; // Variable for local 'from' date
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            css: 'betting', // CSS class for styling
            scroll: true, // Enable scrolling
            responsive: true, // Enable responsive design
            rows: [
                // Define the layout rows
                {
                    view: 'template', // Template view for custom HTML
                    template: "<div id='BIA_client_container'></div>", // HTML template
                    scroll: 'y', // Enable vertical scrolling
                },
            ],
        };
    }

    /**
     * Initializes the BettingView, setting up necessary variables and API calls.
     */
    init() {
        var initThis = this; // Reference to the current instance
        var lng = 'es-ES'; // Default language set to Spanish
        if (this.app.getService('locale').getLang() == 'en') {
            // Check for English language
            lng = 'en'; // Set language to English
        } else {
            lng = 'es-ES'; // Default to Spanish
        }
        var skinIdITN; // Variable for skin ID
        if (
            profile.skinIdITN == undefined || // Check if skinIdITN is undefined
            profile.skinIdITN == undefined || // Duplicate check (likely a typo)
            profile.skinIdITN == null // Check if skinIdITN is null
        ) {
            skinIdITN = 'doradobet'; // Set default skin ID
        } else {
            skinIdITN = profile.skinIdITN; // Use the defined skin ID
        }
        webix.ajax().get(devConfig.geturlApi() + 'Client/GetTokenBetting', '', {
            // API call to get betting token
            error: function (text, data, XmlHttpRequest) {
                // Error handling
                webix.message('Error! '); // Display error message
            },
            success: function (text, data, XmlHttpRequest) {
                // Success handling
                var text = JSON.parse(text); // Parse the response text
                if (!text.HasError) {
                    // Check for errors in the response
                    var options = {
                        // Options for BetinactionAPI
                        token: text.data, // Token from the response
                        skinid: skinIdITN, // Skin ID
                        walletcode: profile.walletcodeSportbookITN, // Wallet code
                        full: true, // Full option
                        page: 'prelive', // Page type
                        lang: lng, // Language
                        fixed: false, // Fixed option
                    };
                    var BIA = new BetinactionAPI( // Instantiate BetinactionAPI
                        '#BIA_client_container', // Container for the API
                        options, // Options for the API
                    );
                } else {
                    webix.message('Error! '); // Display error message if there's an error
                }
            },
        });
    }
}

// FILE DOCUMENTED
